<template>
  <form class="form form-remind-password" @submit.prevent="postRemindPassword">
    <page-title :title="'Przywracanie hasła'" :back="true"></page-title>
    <slide-y-up-transition :duration="500" :delay="200">
      <div v-show="show" class="box-info text-center">Wpisz swój numer telefonu aby odzyskać hasło.</div>
    </slide-y-up-transition>
    <slide-x-left-transition :duration="400" :delay="200">
      <div class="form-group" v-show="show">
        <label>Numer telefonu</label>
        <div class="input-wrapper">
          <input v-model="form.phone_number"
                 v-mask="'XXXXXXXXX'"
                 type="tel"
                 :class="{'input-error' : errors.phone_number }"
                 placeholder="Podaj swój numer telefonu"
                 ref="phoneNumberInput"
                 required/>
        </div>
        <p class="error" v-if="errors.phone_number">{{ errors.phone_number[0] }}</p>
      </div>
    </slide-x-left-transition>
    <ion-button mode="ios" expand="block" type="submit" :disabled="loading">
      <span v-if="loading"><span class="loader"></span></span>
      <span v-else>Przyślij mi token</span>
    </ion-button>
  </form>
</template>

<script>
  import { mapState } from 'vuex'
  import PageTitle from '@/components/PageTitle.vue';

  export default {
    name: 'FormRemindPassword',
    components: { PageTitle },
    computed: {
      ...mapState({
        loading: state => state.restore.loading,
        errors: state => state.restore.errors
      })
    },
    data() {
      return {
        show: false,
        step: 1,
        form: {
          phone_number : '',
        }
      }
    },
    mounted(){
      this.show = true;
      setTimeout(() => {
        this.$refs.phoneNumberInput.focus();
      },1000)
    },
    methods: {
      postRemindPassword() {
        this.$store.dispatch('RESTORE_REQUEST', this.form).then(() => {
          this.$router.push({name: 'ResetPassword'}).catch(err => {})
          this.$store.dispatch('GLOBAL_TOAST','Wysłano token SMS.');
        })
      }
    }
  }
</script>